import { createContext } from 'preact'
import { PartialCoreAnalyticsGAData } from '../types'

interface AppContextType {
  sendGaEvent: (event: PartialCoreAnalyticsGAData) => void
  sendError: (message: string) => void
}

export const AppContext = createContext<AppContextType>({
  sendGaEvent: () => {},
  sendError: () => {},
})
